import { franquiciaService } from '@/_services';

export const franquicia = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getFranquiciasByIdRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    cancelFranquiciasByIdRequest(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getFranquiciasByIdSuccess(state, franquicia) {
      state.list.data = franquicia;
      state.list.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getFranquiciasById({ commit }) {
      commit('getFranquiciasByIdRequest');
      franquiciaService
        .getFranquiciasById()
        .then((franquicias) => {
          commit('getFranquiciasByIdSuccess', franquicias);
        })
        .catch((error) => {
          commit('cancelFranquiciasByIdRequest', error);
        });
    },
  },
};

